"use strict";
var button_checkbox_directive_1 = require('./buttons/button-checkbox.directive');
var button_radio_directive_1 = require('./buttons/button-radio.directive');
var button_checkbox_directive_2 = require('./buttons/button-checkbox.directive');
exports.ButtonCheckboxDirective = button_checkbox_directive_2.ButtonCheckboxDirective;
var button_radio_directive_2 = require('./buttons/button-radio.directive');
exports.ButtonRadioDirective = button_radio_directive_2.ButtonRadioDirective;
exports.BUTTON_DIRECTIVES = [button_checkbox_directive_1.ButtonCheckboxDirective, button_radio_directive_1.ButtonRadioDirective];



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/buttons.js
 ** module id = 688
 ** module chunks = 0
 **/